module.exports = __webpack_public_path__ + "media/images/misc/button-gloss-393479ead3ea7e65054e751132cfd51affe8b143dd36ca09e455ebcbc6b4403c.png";